/* eslint-disable no-nested-ternary */
import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { bool, func, object, string } from 'prop-types';
import React from 'react';
import { useDrop } from 'react-dnd';

const Category = ({
  accept,
  isLastItemCorrect,
  lastDroppedItem,
  onDrop,
  title,
}) => {
  const { isTabletSM } = useScreenSize();

  const [{ isHovering }, drop] = useDrop({
    accept,
    collect: (monitor) => ({
      isHovering: monitor.isOver(),
    }),
    drop: onDrop,
  });

  const backgroundColor = isHovering
    ? theme.colors.schoolBusYellow[100]
    : lastDroppedItem && !isLastItemCorrect
      ? theme.colors.red[20]
      : theme.colors.white[10];

  const borderColor = isHovering
    ? theme.colors.schoolBusYellow[100]
    : lastDroppedItem && !isLastItemCorrect
      ? theme.colors.red[20]
      : theme.colors.white[10];

  const titleColor = isHovering
    ? theme.colors.hunterGreen[100]
    : theme.colors.white[100];

  return (
    <Flex
      ref={drop}
      alignItems="center"
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      borderStyle="solid"
      borderWidth={1}
      flex={isTabletSM ? 0.5 : 1}
      height={148}
      justifyContent="center"
    >
      <Typography
        color={titleColor}
        textAlign="center"
        variant={isTabletSM ? 'BN-bold-s24-lh21' : 'BN-bold-s43-lh38'}
      >
        {title?.toUpperCase()}
      </Typography>
    </Flex>
  );
};

Category.propTypes = {
  accept: string.isRequired,
  isLastItemCorrect: bool.isRequired,
  lastDroppedItem: object.isRequired,
  onDrop: func.isRequired,
  title: string.isRequired,
};

export default Category;
